import apiWorker from '../apiWorker'

const partner_errors = {
    create : (data) => apiWorker('post', `/v1/api/partner_errors`, data),
}

export default partner_errors;